export default "__VITE_ASSET__84550ad5__"